module.exports = __webpack_public_path__ + "9c70ca2358fe4b9db7ba62dcd51fed53.svg";